/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rejectReason: NonNullable<unknown> }} Coinvestments_Tracking_Reject_Tooltipreason2Inputs */

const en_coinvestments_tracking_reject_tooltipreason2 = /** @type {(inputs: Coinvestments_Tracking_Reject_Tooltipreason2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reason: ${i?.rejectReason}`)
};

/**
* | output |
* | --- |
* | "Reason: {rejectReason}" |
*
* @param {Coinvestments_Tracking_Reject_Tooltipreason2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_reject_tooltipreason2 = /** @type {((inputs: Coinvestments_Tracking_Reject_Tooltipreason2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Reject_Tooltipreason2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_reject_tooltipreason2(inputs)
});
export { coinvestments_tracking_reject_tooltipreason2 as "coInvestments_tracking_reject_tooltipReason" }